import { useNavigate } from "react-router-dom";
import "./GuideProfile.css";
import "./GuideProfileSetting.css";
import { FaEnvelope, FaPhone, FaIdCard, FaMoneyBillWave, FaCheckCircle, FaHiking, FaCity, FaUser, FaLanguage } from "react-icons/fa";
import guideImg from "../assets/guide.png"
import NavUser from "../components/NavUser";



function GuideProfileSetting() {
    const navigate = useNavigate();
    return (
        <div>
            <NavUser />
            <div className="guider-profile-container">
                {/* Profile Section */}
                <section className="guider-profile-header">
                    <img src={guideImg} alt="Guide" className="guider-profile-image" />
                    <div className="guider-details">
                        <h2 className="guider-name">John Doe</h2>
                        <p className="guider-languages">Speaks: English, French, Spanish | Guide</p>
                    </div>
                </section>
                {/* Two-column section */}
                <section className="guider-profile-body">
                    <div className="guider-left-column">
                        {/* Contact Section */}
                        <h3 className="section-title">Contact</h3>
                        <div className="info-item">
                            <FaEnvelope className="info-icon" />
                            <div className="info-text">
                                <h4>Email</h4>
                                <p>guide@example.com</p>
                            </div>
                        </div>
                        <div className="info-item">
                            <FaPhone className="info-icon" />
                            <div className="info-text">
                                <h4>Phone</h4>
                                <p>+1 234 567 890</p>
                            </div>
                        </div>

                        {/* Verification Section */}
                        <h3 className="section-title">Verification</h3>
                        <div className="info-item">
                            <FaIdCard className="info-icon" />
                            <div className="info-text">
                                <h4>Business Registration</h4>
                                <p>kamal_guide_license.pdf</p>
                            </div>
                        </div>
                        <div className="info-item">
                            <FaCheckCircle className="info-icon" />
                            <div className="info-text">
                                <h4>Government</h4>
                                <p>kamal_nic_front.jpg</p>
                            </div>
                        </div>

                        {/* Payment Section */}
                        <h3 className="section-title">Payment</h3>
                        <div className="info-item">
                            <FaMoneyBillWave className="info-icon" />
                            <div className="info-text">
                                <h4>Bank Account Number</h4>
                                <p>XXXX-XXXX-1234</p>
                            </div>
                        </div>
                    </div>

                    <div className="guider-right-column">
                        {/* Details Section */}
                        <h3 className="section-title">Details</h3>
                        <div className="info-item">
                            <FaLanguage className="info-icon" />
                            <div className="info-text">
                                <h4>Languages</h4>
                                <p>Sinhala, English</p>
                            </div>
                        </div>
                        <div className="info-item">
                            <FaCity className="info-icon" />
                            <div className="info-text">
                                <h4>Service Area</h4>
                                <p>Ella, Badulla, Haputale</p>
                            </div>
                        </div>
                        <div className="info-item">
                            <FaHiking className="info-icon" />
                            <div className="info-text">
                                <h4>Tour Types Offered</h4>
                                <p>Hiking, Waterfall Tours, Nature Walks</p>
                            </div>
                        </div>
                        <div className="info-item">
                            <FaUser className="info-icon" />
                            <div className="info-text">
                                <h4>About Me</h4>
                                <p>Nature lover and certified local hiking guide with 5+ years of experience around Ella.</p>
                            </div>
                        </div>
                        <button
                            className="add-payment-btn"
                            onClick={() => navigate("/paymentdetails")}
                        >
                            + Add Payment Details
                        </button>
                    </div>
                </section>

            </div>
        </div>
    );
}

export default GuideProfileSetting;
